/* eslint-disable */

import $ from 'jquery';

var popupTimer;

function delayPopup(popup) {
  popupTimer = setTimeout(function() {
    $(popup).popup('hide');
  }, 1000);
}

function copy(parent) {
  navigator.clipboard.writeText(parent.textContent);

  $(parent)
    .popup({
      content: 'Valeur copiée dans le presse-papier',
      on: 'manual',
      exclusive: true,
    })
    .popup('show');

  delayPopup(parent);
}

export default function bind() {
  $('.copyField').on('click', event => {
    const parent = event.currentTarget.parentElement;
    copy(parent);
  });

  $('.copyField2').on('click', event => {
    const parent = event.currentTarget.parentElement.parentElement;
    copy(parent);
  });
}



// WEBPACK FOOTER //
// ./src/plugins/copyField.js